import { Grid, Typography } from '@mui/material';
import type { ODSMenuListItemProps } from '@telekom-ods/react-ui-kit';
import { useState, useEffect } from 'react';

import Provision from '../../../../api/provision';
import { ODSSelect } from '../../../../components/InputFields/index';
import Modal from '../../../../components/Modal';
import useApiQuery from '../../../../hooks/useApiQuery';

import ForecastSummary from './ForecastSummary';
import UsageSummary from './UsageSummary';
import VirtualCloudsSummary from './VirtualCloudsSummary';

import type { VirtualCloud } from '@/types/cloudTypes';

export interface SummariesProps {
  juiceGroup: string;
  onClose: () => void;
}

const Summaries: React.FC<SummariesProps> = ({ juiceGroup, onClose }) => {
  const [cloudId, setCloudId] = useState<string>('');

  const {
    data: virtualClouds = [],
    error: fetchError,
    makeApiCall: getVirtualCloudsCall,
  } = useApiQuery<VirtualCloud[]>(Provision.fetchVirtualClouds);

  useEffect(() => {
    if (juiceGroup) {
      getVirtualCloudsCall({ juiceGroups: [juiceGroup] });
    }
  }, [juiceGroup, getVirtualCloudsCall]);

  const menuItems: ODSMenuListItemProps[] = virtualClouds.map((virtualCloud) => ({
    value: virtualCloud.cloud.name,
    label: virtualCloud.cloud.name,
  }));

  const selectedVirtualCloud = virtualClouds.find((vc) => vc.cloud.name === cloudId);

  const handleCloudSelect = (selected: {
    id?: string | undefined;
    value?: string | undefined;
    label?: string;
  }): void => {
    if (selected.value) {
      setCloudId(selected.value);
    }
  };

  return (
    <Modal
      hideActions
      title='Virtual Cloud Summaries'
      onClose={onClose}
      submitLabel='Save'
      error={fetchError}
    >
      <Grid
        container
        direction='column'
        pb={2}
      >
        <Grid item>
          <ODSSelect
            id='cloudDropdown'
            name='cloudDropdown'
            value={cloudId}
            label='Select a cloud to see the available hypervisors'
            onChange={handleCloudSelect}
            menuItems={menuItems}
          />
        </Grid>
        {cloudId && (
          <Grid
            container
            direction='column'
            gap={2}
          >
            <Grid item>
              <Typography
                variant='h5'
                color='primary'
              >
                Forecast Summary
              </Typography>
              <ForecastSummary
                juiceGroup={juiceGroup}
                cloudId={cloudId}
              />
            </Grid>
            <Grid item>
              <Typography
                variant='h5'
                color='primary'
              >
                Virtual Cloud Summary
              </Typography>
              <VirtualCloudsSummary
                virtualCloud={selectedVirtualCloud}
              />
            </Grid>
            <Grid item>
              <Typography
                variant='h5'
                color='primary'
              >
                Usage Summary
              </Typography>
              <UsageSummary
                juiceGroup={juiceGroup}
                cloudId={cloudId}
              />
            </Grid>
          </Grid>
        )}
      </Grid>
    </Modal>
  );
};

export default Summaries;
